import { WithStyles } from '@material-ui/core';
import grey from '@material-ui/core/colors/grey';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { isMobile } from '../utils/MobileCheck';

import { setCourseDetail } from '../actions/search';
import CareerTopicTree from '../components/CareerTopicTree';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ScenarioFactory from '../scenario/SearchScenarioFactory';
const styles = (theme: Theme) =>
	createStyles({
		button: {
			margin: '10px',
		},
		cellItemName: {
			backgroundColor: grey[300],
			minWidth: '160px',
			textAlign: 'right',
			width: '20%',
		},
		cellItemValue: {
			textAlign: 'left',
			width: '80%',
		},
		flex: {
			flex: 1,
		},
		headerName: {
			backgroundColor: grey[300],
		},
		link: {
			color: 'blue',
			cursor: 'pointer',
		},
		mobileCellItemName: {
			alignItems: 'center',
			backgroundColor: grey[300],
			display: 'flex',
			minHeight: '40px',
			minWidth: '10px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileCellItemValue: {
			alignItems: 'center',
			display: 'flex',
			minHeight: '40px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileFlex: {
			flex: 1,
			fontSize: '16px',
		},
		mobileTable: {
			minWidth: '100px',
		},
		paper: {
			minWidth: '700px',
		},
		root: {
			flexGrow: 1,
			padding: 18,
		},
		wrapDiv: {
			margin: '10px',
		},
	});

interface IRouteParams {
	career_id: string;
}

// tslint:disable-next-line: no-empty-interface
interface IRouteState {}

/**
 * 章立て情報
 */
class CourseDetail extends React.Component<IProps> {
	public constructor(props: IProps) {
		super(props);
		if (this.props.careerID) {
			this.props.fetchCourseDetail(this.props.careerID, this.props.token);
		}
	}
	public componentDidMount() {
		window.scrollTo({
			top: 0,
		});
		if (!this.props.match || !this.props.match.params) {
			return;
		}

		const careerID = this.props.match.params.career_id;

		// データ取得処理
		this.props.fetchCourseDetail(careerID, this.props.token);
	}

	public componentWillUnmount() {
		// データを破棄
		this.props.resetCourseDetail();
	}

	public render() {
		const { classes, courseInfo, courseTopics } = this.props;

		return (
			<div className={classes.root}>
				{isMobile() && (
					<>
						<div className={classes.wrapDiv}>
							<Typography
								variant="h6"
								color="inherit"
								className={classes.mobileFlex}
							>
								{i18n.t('CourseDetail_0001')}
							</Typography>
							<Paper style={{ overflowX: 'auto' }}>
								<div className={classes.mobileTable}>
									<div className={classes.mobileCellItemName}>
										{i18n.t('CourseDetail_0002')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{courseInfo.careerTitle}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18n.t('CourseDetail_0003')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{courseInfo.studyTime}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18n.t('CourseDetail_0004')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{courseInfo.note}
									</div>
								</div>
							</Paper>
						</div>
						<div className={classes.wrapDiv}>
							<Typography
								variant="h6"
								color="inherit"
								className={classes.mobileFlex}
							>
								{i18n.t('CourseDetail_0005')}
							</Typography>
							<Paper>
								{courseTopics.map((topic, i) => (
									<CareerTopicTree key={i} {...topic} />
								))}
							</Paper>
						</div>
					</>
				)}
				{!isMobile() && (
					<>
						<div className={classes.wrapDiv}>
							<Typography
								variant="h6"
								color="inherit"
								className={classes.flex}
							>
								{i18n.t('CourseDetail_0001')}
							</Typography>
							<Paper className={classes.paper}>
								<Table>
									<TableBody>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CourseDetail_0002')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{courseInfo.careerTitle}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CourseDetail_0003')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{courseInfo.studyTime}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CourseDetail_0004')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{courseInfo.note}
											</TableCell>
										</TableRow>
									</TableBody>
								</Table>
							</Paper>
						</div>
						<div className={classes.wrapDiv}>
							<Typography
								variant="h6"
								color="inherit"
								className={classes.flex}
							>
								{i18n.t('CourseDetail_0005')}
							</Typography>
							<Paper>
								{courseTopics.map((topic, i) => (
									<CareerTopicTree key={i} {...topic} />
								))}
							</Paper>
						</div>
					</>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state: IRootState) => ({
	courseInfo: state.search.course.courseInfo,
	courseTopics: state.search.course.courseTopics,
	token: state.session.token,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchCourseDetail: (careerId: string, token: string) => {
		const s = ScenarioFactory.createFetchCourseDetail(dispatch, token);
		s.run(careerId);
	},
	resetCourseDetail: () =>
		dispatch(setCourseDetail({ courseInfo: {}, courseTopics: [] })),
});

export interface IApprovalsProps {
	careerID: string;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	RouteComponentProps<IRouteParams, StaticContext, IRouteState> &
	IApprovalsProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(CourseDetail);

const Styled = withStyles(styles)(Connected);

export default Styled as React.ComponentType<IApprovalsProps>;



// WEBPACK FOOTER //
// ./src/containers/CourseDetail.tsx